import React, {Component} from 'react';
import Loader from "../layouts/Loader";

class Uploading extends Component {
    render() {
        return (<Loader />);
    }
}
export default Uploading;
